var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleIconsGoogledocs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 8.04525H13.375V3H7.12547C6.50327 3 6 3.549 6 4.227V19.773C6 20.451 6.50327 21 7.12479 21H16.8752C17.4967 21 18 20.451 18 19.773V8.04525H13.8749ZM13.5002 15.8865H8.62427V14.8635H13.4988V15.8865H13.5002ZM15.375 13.4318H8.62496V12.4088H15.375V13.4318ZM15.375 10.977H8.62496V9.95475H15.375V10.977ZM13.8749 7.5H18L13.8749 3V7.5Z",
    fill: "#2894ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 15.2,
    width: 7.6,
    height: 7.6,
    rx: 0.6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 15.2,
    width: 7.6,
    height: 7.6,
    rx: 0.6,
    stroke: "#E9ECF2",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5535 20.3291C16.719 20.3136 16.8489 20.3063 16.9451 20.3063C17.0414 20.3063 17.1661 20.3129 17.3208 20.327C17.2558 20.475 17.1995 20.5905 17.1516 20.6756L17.1516 20.6756C17.1036 20.7608 17.0324 20.8713 16.9361 21.0082L16.8022 20.7709L16.802 20.7705L16.5535 20.3291Z",
    fill: "#0066DA",
    stroke: "#31A8DF",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.051 21.6687C21.1438 21.6123 21.2228 21.5347 21.2778 21.436L21.3878 21.2421L21.9136 20.3078C21.9676 20.2112 21.996 20.1018 21.9961 19.9905C21.5692 19.9343 21.2548 19.9062 21.0527 19.9062C20.8355 19.9062 20.5211 19.9343 20.1094 19.9905C20.2618 20.3924 20.3901 20.6862 20.4943 20.8719C20.5994 21.0592 20.7849 21.3248 21.051 21.6687Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 18.0129C19.3073 17.6319 19.5192 17.338 19.6355 17.1315C19.7292 16.9651 19.8323 16.6995 19.9448 16.3346C19.852 16.2782 19.7455 16.25 19.6355 16.25H18.364C18.254 16.25 18.1475 16.2817 18.0547 16.3346C18.1978 16.7531 18.3193 17.0509 18.419 17.228C18.5293 17.4238 18.7229 17.6854 18.9998 18.0129Z",
    fill: "#00832D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1104 19.9844H17.8904L16.9453 21.6626C17.0381 21.719 17.1446 21.7473 17.2546 21.7473H20.7462C20.8562 21.7473 20.9627 21.7155 21.0555 21.6626L20.1104 19.9844Z",
    fill: "#2684FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 18.0064L18.0551 16.3281C17.9623 16.3845 17.8833 16.4621 17.8283 16.5608L16.0825 19.6635C16.0285 19.7601 16.0001 19.8695 16 19.9808H17.8901L19.0002 18.0064Z",
    fill: "#00AC47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0448 18.1122L20.1719 16.5608C20.1169 16.4621 20.0378 16.3845 19.945 16.3281L19 18.0064L20.11 19.9808H21.9967C21.9967 19.8715 21.9692 19.7622 21.9142 19.6635L21.0448 18.1122Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsGoogledocs);
export default __webpack_public_path__ + "static/media/simple-icons_googledocs.54ce9b6450e202daa33a0d1e6dd7a7f8.svg";
export { ForwardRef as ReactComponent };